import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { setSeo } from "../lib/seo";

const PRIVATE = /^\/(admin|seller|rider|account|cart|checkout|orders|invoice|order-success|wishlist|login|register|forgot-password|reset-password|grocery-list)/;
const PUBLIC = /^\/($|products$|product\/[^/]+$|category\/[^/]+$|help$|compare$|policies\/[^/]+$)/;
const SITE = process.env.REACT_APP_SITE_URL;
const onSite = typeof window !== "undefined" && window.location.hostname.replace(/^www\./, "") === new URL(SITE).hostname.replace(/^www\./, "");

const DEFAULTS = {
  "/": ["EAZYSHOPY: Online Shopping for Mobiles, Fashion & Groceries", "Shop mobiles, electronics, fashion, groceries, books and more on EAZYSHOPY. Fast delivery across India, cash on delivery, easy returns and multi-view product photos."],
  "/products": ["Shop All Products Online at Best Prices in India | EAZYSHOPY", "Browse thousands of products on EAZYSHOPY – mobiles, laptops, TVs, fashion, home, beauty and daily groceries with fast delivery and cash on delivery."],
  "/help": ["Help & Support: Orders, Returns, Delivery & Refunds | EAZYSHOPY", "Get help with your EAZYSHOPY orders, returns, refunds, delivery and payments. Chat with support, raise a ticket or call us for quick answers."],
  "/compare": ["Compare Products Side by Side: Specs & Prices | EAZYSHOPY", "Compare phones, laptops and more side by side on EAZYSHOPY. See prices, specs, ratings and offers together before you buy."],
  "/login": ["Login to Your EAZYSHOPY Account | Shop Online India", "Sign in to EAZYSHOPY to track orders, manage your cart and wishlist, and shop with fast delivery across India."],
  "/register": ["Create Your EAZYSHOPY Account | Sell, Shop or Deliver", "Join EAZYSHOPY as a customer, seller or delivery rider and start shopping, selling or earning today."],
};

const tag = (sel, make) => document.head.querySelector(sel) || document.head.appendChild(make());

export default function SeoCanonical() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    const d = DEFAULTS[pathname];
    if (d) setSeo(...d);
    else if (PRIVATE.test(pathname)) setSeo("EAZYSHOPY – Your Account, Cart, Orders & Seller Hub", DEFAULTS["/"][1]);
  }, [pathname]);
  useEffect(() => {
    const cat = new URLSearchParams(search).get("category");
    const path = pathname === "/products" && cat ? `/category/${cat}` : pathname;
    tag('link[rel="canonical"]', () => Object.assign(document.createElement("link"), { rel: "canonical" })).href = SITE + path;
    tag('meta[name="robots"]', () => Object.assign(document.createElement("meta"), { name: "robots" })).content =
      !onSite || PRIVATE.test(pathname) || !PUBLIC.test(pathname) || (pathname === "/products" && [...new URLSearchParams(search).keys()].some((k) => k !== "category")) ? "noindex, follow" : "index, follow";
  }, [pathname, search]);
  return null;
}
